export const englishUser = {
  formTitleFirst: "Registation ",
  formTitleSecond: "Form",
  name: "Name",
  namePlaceholder: "Enter your name",
  email: "Email",
  emailPlaceholder: "Enter your email",
  phoneNumberPlaceholder: "Enter your phone number",
  phoneNumber: "Phone Number",
  description: "Description",
  age: "Age",
  agePlaceholder: "Enter your age",
  addressPlaceholder: "Enter your address",
  address: "Address",
  closedCity: "City",
  closedCityPlaceholder: "Select your city",
  districtPlaceholder: "Select your district",
  district: "District",
  districtList: {
    ampara: "Ampara",
    anuradhapura: "Anuradhapura",
    badulla: "Badulla",
    batticaloa: "Batticaloa",
    colombo: "Colombo",
    galle: "Galle",
    gampaha: "Gampaha",
    hambantota: "Hambantota",
    jaffna: "Jaffna",
    kalutara: "Kalutara",
    kandy: "Kandy",
    kegalle: "Kegalle",
    kilinochchi: "Kilinochchi",
    kurunegala: "Kurunegala",
    mannar: "Mannar",
    matale: "Matale",
    matara: "Matara",
    monaragala: "Monaragala",
    mullaitivu: "Mullaitivu",
    nawaraeliya: "Nuwara Eliya",
    polonnaruwa: "Polonnaruwa",
    puttalam: "Puttalam",
    ratnapura: "Ratnapura",
    trincomalee: "Trincomalee",
    Vavuniya: "Vavuniya",
  },
  submit: "Submit",
  back: "Back",
  successMsg:
    "Registration Successful! You have been successfully registered as a Driving School.",
  errorMsg: "Failed to submit data. Please try again.",
};


export const sinhalaUser = {
  formTitle: "ලියාපදිංචි කිරීමේ පෝරමය",
  formTitleFirst: "ලියාපදිංචි කිරීමේ ",
  formTitleSecond: "පෝරමය",
  name: "නම",
  namePlaceholder: "ඔබගේ නම ඇතුලත් කරන්න",
  emailPlaceholder: "ඔබගේ ඊමේල් ලිපිනය ඇතුලත් කරන්න",
  email: "ඊමේල්",
  phoneNumber: "දුරකථන අංකය",
  phoneNumberPlaceholder: "ඔබගේ දුරකථන අංකය ඇතුලත් කරන්න",
  description: "විස්තරය",
  descriptionPlaceholder: "ඔබගේ විස්තරය ඇතුලත් කරන්න",
  agePlaceholder: "ඔබගේ වයස ඇතුලත් කරන්න",
  age: "වයස",
  address: "ලිපිනය",
  addressPlaceholder: "ඔබගේ ලිපිනය ඇතුලත් කරන්න",
  closedCityPlaceholder: "ඔබගේ නගරය තෝරන්න",
  closedCity: "නගරය",
  district: "දිස්ත්‍රික්කය",
  districtPlaceholder: "ඔබගේ දිස්ත්‍රික්කය තෝරන්න",
  districtList: {
    ampara: "	අම්පාර",
    anuradhapura: "අනුරාධපුර",
    badulla: "බදුල්ල",
    batticaloa: "මඩකලපුව",
    colombo: "කොළඹ",
    galle: "ගාල්ල",
    gampaha: "ගම්පහ",
    hambantota: "හම්බන්තොට",
    jaffna: "යාපනය",
    kalutara: "කළුතර",
    kandy: "මහනුවර",
    kegalle: "	කෑගල්ල",
    kilinochchi: "කිලිනොච්චි",
    kurunegala: "කුරුණෑගල",
    mannar: "මන්නාරම",
    matale: "මාතලේ",
    matara: "මාතර",
    monaragala: "මොණරාගල",
    mullaitivu: "මුලතිව්",
    nawaraeliya: "නුවරඑළිය",
    polonnaruwa: "පොළොන්නරුව",
    puttalam: "	පුත්තලම",
    ratnapura: "රත්නපුර",
    trincomalee: "ත්‍රිකුණාමලය",
    Vavuniya: "වවුනියාව",
  },
  submit: "තොරතුරු ඇතුලත් කරන්න",
  back: "ආපසු",
  successMsg:
    "ලියාපදිංචිය සාර්ථකයි! ඔබ රියදුරු පාසලක් ලෙස සාර්ථකව ලියාපදිංචි වී ඇත.",
  errorMsg: "දත්ත සුරැකීම අසාර්ථකයි. කරුණාකර නැවත උත්සාහ කරන්න.",
};


export const tamilUser = {
  formTitle: "பதிவு படிவம்",
  formTitleFirst: "பதிவு ",
  formTitleSecond: "படிவம்",
  name: "பெயர்",
  namePlaceholder: "உங்கள் பெயரை உள்ளிடவும்",
  emailPlaceholder: "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
  email: "மின்னஞ்சல்",
  phoneNumber: "மொபைல் எண்",
  phoneNumberPlaceholder: "உங்கள் மொபைல் எண் உள்ளிடவும்",
  descriptionPlaceholder: "உங்கள் விவரங்களை உள்ளிடவும்",
  description: "விளக்கம்",
  age: "வயது",
  agePlaceholder: "உங்கள் வயதை உள்ளிடவும்",
  addressPlaceholder: "உங்கள் முகவரியை உள்ளிடவும்",
  address: "முகவரி",
  closedCity: "நகரம்",
  closedCityPlaceholder: "உங்கள் நகரத்தை உள்ளிடவும்",
  districtPlaceholder: "உங்கள் மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
  district: "மாவட்டம்",
  districtList: {
    ampara: "அம்பாறை",
    anuradhapura: "அனுராதபுரம்",
    badulla: "பதுளை",
    batticaloa: "மட்டக்களப்பு",
    colombo: "கொழும்பு",
    galle: "காலி",
    gampaha: "கம்பகா",
    hambantota: "அம்பாந்தோட்டை",
    jaffna: "யாழ்ப்பாணம்",
    kalutara: "களுத்துறை",
    kandy: "கண்டி",
    kegalle: "கேகாலை",
    kilinochchi: "கிளிநொச்சி",
    kurunegala: "குருணாகல்",
    mannar: "மன்னார்",
    matale: "மாத்தளை",
    matara: "மாத்தறை",
    monaragala: "மொனராகலை",
    mullaitivu: "முல்லைத்தீவு",
    nawaraeliya: "நுவரெலியா",
    polonnaruwa: "பொலன்னறுவை",
    puttalam: "புத்தளம்",
    ratnapura: "இரத்தினபுரி",
    trincomalee: "திருகோணமலை",
    Vavuniya: "வவுனியா",
  },
  submit: "சமர்ப்பிக்கவும்",
  back: "பின்னே",
  successMsg:
    "பதிவுசெய்தல் வெற்றிகரமாக முடிந்தது! நீங்கள் ஓர் டிரைவிங் பள்ளியாக வெற்றிகரமாக பதிவு செய்யப்பட்டுள்ளீர்கள்.",
  errorMsg:
    "தரவு சமர்ப்பிப்பு தோல்வியடைந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
};